export default {
  shape:
    '<path fill="#fff" d="m7.325 19.375 1.25-5.325L4.45 10.5l5.425-.475L12 5l2.125 5.025 5.425.475-4.125 3.55 1.25 5.325L12 16.55l-4.675 2.825Z"/>',
  viewBox: [0, 0, 24, 24],
};
